export default {
  namespaced: true,
  state:{    
    healthInsurances: [],    
    healthInsuranceCreate: {
      modal: false,
      values: {}
    },
    healthInsuranceEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    healthInsurances(state){
      return state.healthInsurances;
    },   
    healthInsuranceCreate(state) {
        return state.healthInsuranceCreate;
    },
    healthInsuranceEdit(state) {
      return state.healthInsuranceEdit;
    }    
  },
  mutations:{
    SET_HEALTH_INSURANCES(state, values){
      state.healthInsurances = values;
    },
    SET_HEALTH_INSURANCE_CREATE_MODAL(state, value) {
      state.healthInsuranceCreate.modal = value;
    },
    SET_HEALTH_INSURANCE_CREATE_VALUES(state, value) {
      state.healthInsuranceCreate.values = value;
    },
    SET_HEALTH_INSURANCE_EDIT_MODAL(state, value) {
      state.healthInsuranceEdit.modal = value;
    },
    SET_HEALTH_INSURANCE_EDIT_VALUES(state, value) {
      state.healthInsuranceEdit.values = value;
    },
    PUSH_HEALTH_INSURANCE(state, value){
      state.healthInsurances.push(value);
    },    
    SET_UPDATE_HEALTH_INSURANCE(state, values){
      var editedIndex = state.healthInsurances.map(healthInsurance => healthInsurance.id).indexOf(values.id);      
      if (editedIndex > -1){
        Object.assign(state.healthInsurances[editedIndex], values);              
      }
      return;
    },
    SPLICE_HEALTH_INSURANCE(state, value){
      let i = state.healthInsurances.map(healthInsurance => healthInsurance.id).indexOf(value);      
      state.healthInsurances.splice(i, 1);
    }
  },
  actions:{
    getHealthInsurances({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/health-insurances').then((response) => {
          commit('SET_HEALTH_INSURANCES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    healthInsuranceStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/health-insurances', formData).then((response) => {
          commit('PUSH_HEALTH_INSURANCE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    healthInsuranceUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/health-insurances/' + value, payload).then((response) => {          
          commit('SET_UPDATE_HEALTH_INSURANCE', response.data.data);
          resolve(response);   
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteHealthInsurance({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/health-insurances/' + value).then((response) => {
          commit('SPLICE_HEALTH_INSURANCE', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });      
    },
  }
}
